import { APP_INITIALIZER, NgModule } from '@angular/core';
import { provideHttpClient, withInterceptorsFromDi, withXhr } from '@angular/common/http';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { ServiceWorkerModule } from '@angular/service-worker';
import { Capacitor } from '@capacitor/core';
import {
  MetaLoader,
  MetaModule,
  MetaStaticLoader,
  PageTitlePositioning,
} from './meta';
import { SocialLoginModule, GoogleSigninButtonModule, SOCIAL_AUTH_CONFIG as SOCIAL_AUTH_TOKEN } from '@abacritt/angularx-social-login';
import { environment } from '../environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ComponentsModule } from './components/components.module';
import { AlertComponent } from './directives';
import { AuthGuard } from './guards';
import { httpInterceptorProviders } from './helpers/httpInterceptors';
import { MessagesComponent } from './messages/messages.component';
import { MessageDetailComponent } from './messages/message-detail/message-detail.component';
import { AlertService, UserService } from './services';
import { GoogleAnalyticsService } from './services/google-analytics.service';
import { loadGoogleMapsApi } from './services/google-maps-loader';
import { SOCIAL_AUTH_CONFIG } from './social.auth';
import { NgxStripeModule } from 'ngx-stripe';
import { UtilsModule } from './utils/utils.module';

export function metaFactory(): MetaLoader {
  return new MetaStaticLoader({
    pageTitlePositioning: PageTitlePositioning.PrependPageTitle,
    pageTitleSeparator: ' - ',
    applicationName: 'activity8',
    defaults: {
      title: 'Ready . Play . Earn!',
      description: 'I thought you may like this on activity8 app 🤍 ',
      'og:image':
      'https://activity8.app/assets/img/activity8-logo.png',
      'og:type': 'website',
      'og:locale': 'en_US',
    },
  });
}

@NgModule({
  declarations: [AppComponent, MessagesComponent, MessageDetailComponent, AlertComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: environment.production && !Capacitor.isNativePlatform(),
    }),
    BrowserAnimationsModule,
    RouterModule,
    ComponentsModule,
    UtilsModule,
    SocialLoginModule.initialize(SOCIAL_AUTH_CONFIG),
    GoogleSigninButtonModule,
    NgxStripeModule.forRoot(environment.stripePublishableKey),
    MetaModule.forRoot({
      provide: MetaLoader,
      useFactory: metaFactory,
    }),
  ],
  providers: [
    provideHttpClient(withXhr(), withInterceptorsFromDi()),
    {
      provide: APP_INITIALIZER,
      useFactory: () => loadGoogleMapsApi(environment.googleMapsApiKey),
      multi: true,
    },
    { provide: SOCIAL_AUTH_TOKEN, useValue: SOCIAL_AUTH_CONFIG },
    GoogleAnalyticsService,
    AuthGuard,
    UserService,
    httpInterceptorProviders,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
